const dataTableData = {
  columns: [
    { Header: "#", accessor: "id", width: "10%" },
    { Header: "اسم القسم", accessor: "name", width: "20%" },
    { Header: "الشركة", accessor: "companyName", width: "20%" },
    // { Header: "الوصف", accessor: "description", width: "30%" },
    { Header: "اجراء", accessor: "actions", width: "20%" },
  ],

  rows: [], // Will be populated with API data
};

export default dataTableData;
